/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import SoftTypography from "components/SoftTypography";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function Table12({ formData, setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      yearAppropriation: "",
      provisionAppropriation: "",
      moneyAppropriation4: 0,
      moneyAppropriation5: 0,
      moneyAppropriation6: 0,
      moneyAppropriation7: 0,
      moneyAppropriation8: 0,
      moneyAppropriation9: 0,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);
  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        yearAppropriation: "",
        provisionAppropriation: "",
        moneyAppropriation4: 0,
        moneyAppropriation5: 0,
        moneyAppropriation6: 0,
        moneyAppropriation7: 0,
        moneyAppropriation8: 0,
        moneyAppropriation9: 0,
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };
  //
  const [data2, setData2] = useState([
    {
      id: uuidV4(),
      yearAppropriation: "",
      provisionAppropriation: "",
      moneyAppropriation4: 0,
      moneyAppropriation5: 0,
      moneyAppropriation6: 0,
      moneyAppropriation7: 0,
      moneyAppropriation8: 0,
      moneyAppropriation9: 0,
      moneyAppropriation10: 0,
      moneyAppropriation11: 0,
      moneyAppropriation12: 0,
      moneyAppropriation13: 0,
      moneyAppropriation14: 0,
      moneyAppropriation15: 0,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable2", data2);
  }, [data2]);
  const handleChange2 = (values) => {
    const { id, name, value, type } = values;
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate2 = (date, id) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect2 = (id, name, value) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd2 = () => {
    setData2((prev) => [
      ...prev,
      {
        id: uuidV4(),
        yearAppropriation: "",
        provisionAppropriation: "",
        moneyAppropriation4: 0,
        moneyAppropriation5: 0,
        moneyAppropriation6: 0,
        moneyAppropriation7: 0,
        moneyAppropriation8: 0,
        moneyAppropriation9: 0,
        moneyAppropriation10: 0,
        moneyAppropriation11: 0,
        moneyAppropriation12: 0,
        moneyAppropriation13: 0,
        moneyAppropriation14: 0,
        moneyAppropriation15: 0,
      },
    ]);
  };
  const handleDelete2 = (id) => {
    setData2((prev) => prev.filter((item) => item.id !== id));
  };
  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={1}
                style={{ textAlign: "center", minWidth: 10 }}
              >
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Năm trích lập
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Mức trích lập trong kỳ tính thuế
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số tiền trích lập trong kỳ tính thuế
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số nhận điều chuyển trong kỳ tính thuế
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số điều chuyển trong kỳ tính thuế
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số tiền đã sử dụng trong kỳ tính thuế trước
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số tiền đã sử dụng trong kỳ tính thuế này
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số tiền được chuyển sang các kỳ tính thuế sau
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>(1)</Td>
              <Td style={{ textAlign: "center" }}>(2)</Td>
              <Td style={{ textAlign: "center" }}>(3)</Td>
              <Td style={{ textAlign: "center" }}>(4)</Td>
              <Td style={{ textAlign: "center" }}>(5)</Td>
              <Td style={{ textAlign: "center" }}>(6)</Td>
              <Td style={{ textAlign: "center" }}>(7)</Td>
              <Td style={{ textAlign: "center" }}>(8)</Td>
              <Td style={{ textAlign: "center" }}>(9)=(4)+(5)-(6)-(7)-(8)</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="yearAppropriation"
                    value={item.yearAppropriation}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="provisionAppropriation"
                    value={item.provisionAppropriation}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation4"
                    value={item.moneyAppropriation4}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation5"
                    value={item.moneyAppropriation5}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation6"
                    value={item.moneyAppropriation6}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation7"
                    value={item.moneyAppropriation7}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation8"
                    value={item.moneyAppropriation8}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                    textAlign: "center",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation9"
                    value={item.moneyAppropriation9}
                    onChange={handleChange}
                    readOnlyBackground={true}
                    readOnly={true}
                    fontWeight="bold"
                  />
                </Td>
              </tr>
            ))}
            <tr key={1000}>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
                colSpan={3}
              >
                Tổng cộng:
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <InputTable readOnlyBackground={true} readOnly={true} fontWeight="bold" value={0} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  fontWeight={"bold"}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  fontWeight={"bold"}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  fontWeight={"bold"}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  fontWeight={"bold"}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  fontWeight={"bold"}
                  value={0}
                />
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
      <Grid item xs={12} style={{ paddingTop: 0 }}>
        <SoftBox ml={0.5} lineHeight={0} display="inline-block">
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            III. Xử lý Quỹ khi doanh nghiệp không sử dụng, sử dụng không hết và sử dụng không đúng
            mục đích
          </SoftTypography>
        </SoftBox>
      </Grid>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", minWidth: 10 }}
              >
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Năm trích lập
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mức trích lập trong kỳ tính thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền trích lập trong kỳ tính thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số nhận điều chuyển trong kỳ tính thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số điều chuyển trong kỳ tính thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền đã sử dụng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền đã nộp về Quỹ phát triển KHCN
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Xử lý Quỹ khi doanh nghiệp không sử dụng, sử dụng không hết và sử dụng không đúng
                mục đích
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Thuế suất thuế TNDN (%)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Thuế TNDN phải nộp
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Tiền lãi phải nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Tổng số tiền phải nộp
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>
                Số tiền Quỹ còn lại do sử dụng không hết 70% số quỹ đã trích lập
              </Td>
              <Td style={{ textAlign: "center" }}>Số tiền Quỹ sử dụng không đúng mục đích</Td>
              <Td style={{ textAlign: "center" }}>Do sử dụng không hết 70% số quỹ đã trích lập</Td>
              <Td style={{ textAlign: "center" }}>Do sử dụng không đúng mục đích</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>(1)</Td>
              <Td style={{ textAlign: "center" }}>(2)</Td>
              <Td style={{ textAlign: "center" }}>(3)</Td>
              <Td style={{ textAlign: "center" }}>(4)</Td>
              <Td style={{ textAlign: "center" }}>(5)</Td>
              <Td style={{ textAlign: "center" }}>(6)</Td>
              <Td style={{ textAlign: "center" }}>(7)</Td>
              <Td style={{ textAlign: "center" }}>(8)</Td>
              <Td style={{ textAlign: "center" }}>(9)</Td>
              <Td style={{ textAlign: "center" }}>(10)</Td>
              <Td style={{ textAlign: "center" }}>(11)</Td>
              <Td style={{ textAlign: "center" }}>(12)=(9+10)x(11)</Td>
              <Td style={{ textAlign: "center" }}>(13)</Td>
              <Td style={{ textAlign: "center" }}>(14)</Td>
              <Td style={{ textAlign: "center" }}>(15)</Td>
            </tr>
            {data2.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete2(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="yearAppropriation"
                    value={item.yearAppropriation}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="provisionAppropriation"
                    value={item.provisionAppropriation}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation4"
                    value={item.moneyAppropriation4}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation5"
                    value={item.moneyAppropriation5}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation6"
                    value={item.moneyAppropriation6}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation7"
                    value={item.moneyAppropriation7}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation8"
                    value={item.moneyAppropriation8}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation9"
                    value={item.moneyAppropriation9}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation10"
                    value={item.moneyAppropriation10}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation11"
                    value={item.moneyAppropriation11}
                    onChange={handleChange2}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation12"
                    value={item.moneyAppropriation12}
                    onChange={handleChange2}
                    readOnlyBackground={true}
                    readOnly={true}
                    fontWeight="bold"
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation13"
                    value={item.moneyAppropriation13}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation14"
                    value={item.moneyAppropriation14}
                    onChange={handleChange2}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                    textAlign: "center",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                  colSpan={2}
                >
                  <InputTable
                    id={item.id}
                    name="moneyAppropriation15"
                    value={item.moneyAppropriation15}
                    onChange={handleChange2}
                    readOnlyBackground={true}
                    readOnly={true}
                    fontWeight="bold"
                  />
                </Td>
              </tr>
            ))}
            <tr key={1100}>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
                colSpan={2}
              >
                Tổng cộng:
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <InputTable readOnlyBackground={true} readOnly={true} fontWeight="bold" value={0} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <InputTable readOnlyBackground={true} readOnly={true} fontWeight="bold" value={0} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <InputTable readOnlyBackground={true} readOnly={true} fontWeight="bold" value={0} />
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd2}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, readOnlyBackground, fontWeight, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: readOnlyBackground === true ? "#ddeff3" : "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        fontWeight: fontWeight,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
